module.exports = __webpack_public_path__ + "img/travel-distance.53dba419.svg";